export const MISCREDUCER = (state = {  filter_to_add: '',
                                       addingFilter: false,
                                       addingSecTab: false,
                                       addingPrimaryTab: false,
                                       addingTemplate: false,
                                       sec_tab_to_add: '',
                                       primary_tabs: { name: '', icon: { selected_icon: undefined, icon_list: [ {text: 'Bar Chart (for Visualize)' , value: 'bar-chart' }, { text: 'Table (for Datasheet)', value: 'table' }, { text: 'Folder Open (for Reports)', value: 'folder-open' }] }, sec_tabs: { options: [], selected: [] }  },
                                       template_to_add: '',
                                       template_report_list: [],
                                       reports_to_add: []
}, action) => {
  switch (action.type) {
    case 'SET_FILTER_TO_ADD':
      return {
        ...state,
        filter_to_add: action.data
      }
    case 'SET_ADDING_FILTER_STATUS':
      return {
        ...state,
        addingFilter: action.data
      }
    case 'SET_SEC_TAB_TO_ADD':
      return {
        ...state,
        sec_tab_to_add: action.data
      }
    case 'SET_ADDING_SEC_TAB_STATUS':
      return {
        ...state,
        addingSecTab: action.data
      }
    case 'SET_PRIMARY_TAB_NAME':
      state.primary_tabs.name = action.data;
      return {
        ...state
      }
    case 'SET_PRIMARY_ICON':
      state.primary_tabs.icon.selected_icon = action.data;
      return {
        ...state
      }
    case 'SET_SEC_TAB_OPTIONS':
      state.primary_tabs.sec_tabs.options = action.data;
      return {
        ...state
      }
    case 'SET_PRIMARY_TAB_SEC_TAB':
      state.primary_tabs.sec_tabs.selected = action.data;
      return {
        ...state
      }
    case 'SET_ADDING_PRIMARY_TAB_STATUS':
      return {
        ...state,
        addingPrimaryTab: action.data
      }
    case 'SET_TEMPLATE_TO_ADD':
      return {
        ...state,
        template_to_add: action.data
      }
    case 'SET_TEMPLATE_REPORT_LIST':
      return {
        ...state,
        template_report_list: action.data
      }
    case 'SET_REPORTS_TO_ADD':
      return {
        ...state,
        reports_to_add: action.data
      }
    case 'SET_ADDING_TEMPLATE_STATUS':
      return {
        ...state,
        addingTemplate: action.data
      }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/Misc/MiscReducer.js